import { render } from "./bindphone.vue?vue&type=template&id=307fbcf6&scoped=true"
import script from "./bindphone.vue?vue&type=script&lang=js"
export * from "./bindphone.vue?vue&type=script&lang=js"

import "./bindphone.vue?vue&type=style&index=0&id=307fbcf6&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307fbcf6"]])

export default __exports__